export const examAdminAssetsCenter = {
  pageTitle: "资产中心",
  pageSubtitle: "统一管理上传资产，支持下载、引用保护删除和批量治理。",
  scopeGlobal: "当前范围：全局资产（管理员）",
  scopeMine: "当前范围：我的资产空间（{username}）",
  searchFilenamePlaceholder: "按文件名/对象键搜索",
  searchContentTypePlaceholder: "按内容类型搜索",
  createAction: "上传资产",
  batchDeleteAction: "批量删除",
  summaryTotal: "资产总数：{count}",
  summarySelected: "已选资产：{count}",
  table: {
    filename: "文件名",
    contentType: "类型",
    sizeBytes: "大小（字节）",
    referenceStatus: "引用状态",
    uploadedAt: "上传时间",
  },
  labels: {
    inUse: "已引用（{count}）",
    notInUse: "未引用",
  },
  messages: {
    uploadSuccess: "资产上传成功",
    deleteSuccess: "资产已删除",
    deleteBlocked: "资产被引用，无法删除（{labels}）",
    selectFileWarning: "请先选择文件",
  },
  confirm: {
    deleteTitle: "确认删除该资产？",
    deleteDescription: "删除前会校验是否被引用。",
    batchDeleteTitle: "确认批量删除选中资产？",
    batchDeleteDescription: "系统会逐条执行引用校验，已引用的资产会被自动跳过并提示。",
    batchDeleteOkText: "确认删除",
  },
  drawer: {
    uploadTitle: "上传资产",
    sceneLabel: "场景标识（可选）",
    scenePlaceholder: "例如：exam_attachment / question_material",
  },
};
